import { PAYMENTS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchCreatePreference = async (body) => {
  const resp = await ApiRequestInterceptor(PAYMENTS.createPreference, "POST", body);

  // Normaliza: a veces viene { code/status }, a veces no; a veces { data }, a veces no
  const code   = resp?.code ?? resp?.status;        // puede ser undefined
  const payload = resp?.data ?? resp?.body ?? resp; // mejor esfuerzo

  // ¿Tenemos un id válido ya sea directo o anidado?
  const hasId =
    (payload && typeof payload === "object" && "id" in payload) ||
    (payload?.data && typeof payload.data === "object" && "id" in payload.data);

  // Si vino code y no es 200/201, o si no vino code pero tampoco logramos detectar un id => error
  if ((code != null && code !== 200 && code !== 201) || (!hasId && code == null)) {
    const msg = payload?.message || payload?.detail || resp?.message || "Failed to create preference";
    throw new Error(msg);
  }

  // Devuelve el objeto que realmente contiene { id }
  return payload?.id ? payload : (payload?.data?.id ? payload.data : payload);
};